import { camelize } from '@angular-devkit/core/src/utils/strings';

export const camelCase = (word: string) => {
  const ret = word[0].toLowerCase() + word.slice(1);
  return ret;
};

/**
 * Return a capitalized camelcase word with
 * - Only alphanumeric character
 * - No spaces or special characters like '-'
 */
 export const getKeyFromText = (text): string => {
  // Capitalize and only accept alphanumerics in keyName: no '-'
  let keyName = text?.replace(/[^a-zA-Z0-9 -]/g, '');
  keyName = camelize(keyName);
  keyName = keyName.charAt(0).toUpperCase() + keyName.slice(1);
  return keyName;
};
